<template>
    <div class="w-100 m-0 d-flex justify-content-center">
        <div class="spinner-container position-relative">
            <img src="@/assets/spinner.png" class="center-hub fa-spin" style="opacity: 1; width: 20vw !important; left: calc(50% - 10vw); top: calc(50% - 10vw);">
        </div>
    </div>
  </template>
  
  <style>
  .spinner-container {
    width: 50vw;
    height: calc(80vh);
  }
  .center-hub {
    width: 100% !important;
  }
  </style>
  
  <script type="text/javascript">
  import { isKnab } from '@/App.vue';
  import { useToast } from 'vue-toastification';
  export default {
    name: 'ResetPasswordPage',
    data() {
        return {}
    },
    methods: {
        async logout() {
            let query = {};
            if(isKnab()) {
                query = {
                    'brand': 'knab',
                }
            }

            localStorage.clear();
            sessionStorage.clear();
                    
            if (window.Chatbot) {
                window.Chatbot.logout();
            }
            
            this.emitter.emit('login', false)

            await this.$router.push({ path: '/login',
                query: query,
            });
        },
    },
    async mounted() {
        let token = window.location.href.split("?")[1];
        if(!token) {
            this.$router.push('/login');
        }
        await this.$http.post('/email/post_change/', {
            token: token,
        }).then(async (response) => {
            let data = response.data;
            if(data.status === 200) {
                const toast = useToast();
                toast.success(data.comments);
                this.$router.push('/login');
                await this.logout();
            } else {
                const toast = useToast();
                toast.error(data.comments);
                this.$router.push('/account');
            }
        });
    }
}
  </script>